import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-50px'
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        {/* Opening Hook */}
        <motion.div {...fadeInUp} className="mb-12" data-id="element-111">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6" data-id="element-112">
            ¿Alguna vez has hecho la cuenta de cuánto dinero le has regalado a
            tu dueño de casa en los últimos 5 años? Si pagas $2,000 de renta,
            has tirado{' '}
            <span className="font-bold text-[#D4A843] text-2xl" data-id="element-113">$120,000</span>{' '}
            a la basura. Dinero que nunca volverá y que solo sirvió para que
            otra familia construyera riqueza, mientras la tuya vive con el miedo
            de que el próximo mes suban la renta otra vez.
          </p>

          <p className="text-lg md:text-xl text-gray-600 italic leading-relaxed mb-6" data-id="element-114">
            Ese sobre blanco en el buzón con el aviso de aumento de renta no es
            solo un gasto extra; es un recordatorio de que no tienes el control
            de tu hogar.
          </p>

          <p className="text-xl md:text-2xl font-bold text-[#D4A843]" data-id="element-115">
            Pero hoy, eso se termina.
          </p>
        </motion.div>

        {/* The Problem */}
        <motion.div {...fadeInUp} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mb-12" data-id="element-116">
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B3A5C] mb-6" data-id="element-117">
            El Problema Real
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-118">
            La mayoría de los trabajadores hispanos en este país creen que para
            comprar una casa necesitan un crédito perfecto de 800 puntos y un
            ahorro de $60,000 dólares. Se pasan años intentando ahorrar, pero la
            inflación y las rentas suben más rápido de lo que pueden guardar.
          </p>

          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-119">
            Sienten que están en una caminadora financiera: trabajan más horas,
            pero la meta de tener casa propia se aleja cada vez más. El banco
            local los rechaza porque el empleado no quiere hacer el papeleo de
            los programas de ayuda, y terminan resignados a rentar para siempre.
          </p>
        </motion.div>

        {/* Failed Attempts */}
        <motion.div {...fadeInUp} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-120">
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B3A5C] mb-6" data-id="element-121">
            Lo Que Has Intentado NO Funciona
          </h2>

          <div className="space-y-4" data-id="element-122">
            <div className="flex items-start gap-3" data-id="element-123">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-124" />
              <p className="text-lg text-gray-700" data-id="element-125">
                <span className="font-semibold" data-id="element-126">Ahorrar el 20%</span> es
                matemáticamente imposible para una familia promedio mientras el
                costo de vida sigue subiendo.
              </p>
            </div>

            <div className="flex items-start gap-3" data-id="element-127">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-128" />
              <p className="text-lg text-gray-700" data-id="element-129">
                <span className="font-semibold" data-id="element-130">
                  Esperar a que bajen los intereses
                </span>{' '}
                te mantiene pagando el 100% de interés a tu dueño de casa todos
                los meses.
              </p>
            </div>

            <div className="flex items-start gap-3" data-id="element-131">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-132" />
              <p className="text-lg text-gray-700" data-id="element-133">
                <span className="font-semibold" data-id="element-134">
                  Confiar en aplicaciones de crédito genéricas
                </span>{' '}
                no te prepara para los requisitos específicos de una hipoteca
                hipotecaria.
              </p>
            </div>

            <div className="flex items-start gap-3" data-id="element-135">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-136" />
              <p className="text-lg text-gray-700" data-id="element-137">
                <span className="font-semibold" data-id="element-138">
                  Buscar casas en Zillow sin una estrategia
                </span>{' '}
                de "vendedor motivado" te hace perder tiempo en propiedades que
                no califican para ayudas.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}